import React, { Suspense }  from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader'; 
import LoadingModal from 'components/presenters/modal/LoadingModal';
import styled from 'styled-components';

export default function BusinessInfoLayout() {
  const BusinessInfo = React.lazy(() => import('components/containers/mypage/BusinessInfo'));
  return (
    <PageLayout>
      <TitleHeader title={"사업자 정보"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/> 
      <Suspense fallback={<LoadingModal zIndex={500}/>}>
        <BusinessInfo />
      </Suspense>
    </PageLayout>
  )
}

const PageLayout = styled.div`
	padding-top : 72px;
`;